<!-- 类似 综合性赛事 的赛程展示结果 -->
<template>
  <div
    class="matchItemRow"
    :class="themeClass === 'onlyDisplay' ? 'onlyDisplay' : ''"
  >
    <span
      class="item_matchLeft"
      :class="[
        viewMode.indexOf('scheduleNotice') === 0 ? 'isShowChannelTvList' : '',
        ['tennis'].includes(matchModeObj.mode) ? 'doubleNationalityOfTeam' : '',
      ]"
    >
      <template v-if="viewMode.indexOf('scheduleNotice') === 0">
        <span class="matchLeft_colum1">
          <span class="matchLeft_colum1_row1">
            <!-- <span
                    v-if="themeClass === 'onlyDisplay'"
                    class="matchLeft_colum1_row1_colum1"
                    v-text="
                      _valPerFormatHandler(
                        `${item.formatDate ? item.formatDate : ''} ${
                          item.matchTime
                        }`
                      )
                    "
                  ></span> -->
            <span
              class="matchLeft_colum1_row1_colum1"
              v-text="
                _valPerFormatHandler(
                  `${item.formatDate ? item.formatDate : ''} ${item.matchTime}`
                )
              "
            ></span>
            <span class="matchLeft_colum1_row1_colum2">
              <span class="national_icon" v-if="item.isChina"></span>
              <span class="medal_icon" v-if="item.isGold"></span>
            </span>
          </span>
          <span
            class="matchLeft_colum2_rowComment"
            v-if="['tennis'].includes(matchModeObj.mode) && item.scheduleComment"
            v-text="item.scheduleComment"
          ></span>
          <span class="matchLeft_colum1_row2" :data="`${chooseState}`">
            <template v-if="chooseState === 'choose'">
              <span
                class="matchItem_checkbox"
                v-for="channelItem in item.channelTvList"
                :class="channelItem.act ? 'act' : ''"
                :key="channelItem.value"
                @click.stop="matchItem_checkbox(item, channelItem)"
              >
                <span class="matchItem_channelItem" :class="channelType">
                  <svg
                    t="1693726421166"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="21127"
                    width="80%"
                    height="80%"
                  >
                    <path
                      d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                      p-id="21128"
                    ></path>
                  </svg>
                </span>
                <span
                  class="matchItem_channelItem_text"
                  v-text="channelItem.name"
                ></span>
              </span>
            </template>
            <template v-else>
              <span
                class="matchItem_checkbox"
                v-for="channelItem in item.channels"
                :key="channelItem.channelId"
              >
                <span
                  class="matchItem_channelItem_text channelName"
                  v-text="channelItem.channelName"
                ></span>
              </span>
            </template>
          </span>
        </span>
        <span class="matchLeft_colum2">
          <span
            class="matchLeft_colum2_row1"
            v-text="_valPerFormatHandler(item.matchName)"
          ></span>
          <span class="matchLeft_colum2_row2">
            <span class="sportHall_icon"></span>
            <span
              class="sportHall_name"
              v-text="
                _valPerFormatHandler(
                  ['tennis'].includes(matchModeObj.mode)
                    ? item.locationName
                    : item.venueName
                )
              "
            ></span>
          </span>
        </span>
      </template>
      <template v-else>
        <span class="matchLeft_colum1">
          <!-- <span
                  v-if="themeClass === 'onlyDisplay'"
                  class="matchLeft_colum1_row1"
                  v-text="
                    _valPerFormatHandler(
                      `${item.formatDate ? item.formatDate : ''} ${
                        item.matchTime
                      }`
                    )
                  "
                ></span> -->
          <span
            class="matchLeft_colum1_row1"
            v-text="
              _valPerFormatHandler(
                `${item.formatDate ? item.formatDate : ''} ${item.matchTime}`
              )
            "
          ></span>
          <span
            class="matchLeft_colum2_rowComment"
            v-if="['tennis'].includes(matchModeObj.mode) && item.scheduleComment"
            v-text="item.scheduleComment"
          ></span>
          <span class="matchLeft_colum1_row2">
            <span class="national_icon" v-if="item.isChina"></span>
            <span class="medal_icon" v-if="item.isGold"></span>
          </span>
        </span>
        <span class="matchLeft_colum2">
          <span
            class="matchLeft_colum2_row1"
            v-text="_valPerFormatHandler(item.matchName)"
          ></span>
          <span class="matchLeft_colum2_row2">
            <span class="sportHall_icon"></span>
            <span
              class="sportHall_name"
              v-text="
                _valPerFormatHandler(
                  ['tennis'].includes(matchModeObj.mode)
                    ? item.locationName
                    : item.venueName
                )
              "
            ></span>
          </span>
        </span>
      </template>
    </span>
    <span
      class="item_matchCenter"
      :class="[
        item.type,
        ['tennis'].includes(matchModeObj.mode) ? 'doubleNationalityOfTeam' : '',
      ]"
    >
      <template
        v-if="
          item.type === sportsTypeArr[0] &&
          ['compreSportsMeet'].includes(matchModeObj.mode)
        "
      >
        <!-- 综合性赛事双打运动员是同一国籍 -->
        <span class="matchCenter_colum1">
          <span class="matchCenter_colum1_row">
            <span class="delegationLogo" :class="item.homeLogo ? 'isLogo' : ''">
              <img v-if="item.homeLogo" :src="item.homeLogo" />
            </span>
            <span
              class="delegationName"
              v-text="_valPerFormatHandler(item.homeName)"
            ></span>
          </span>
          <span class="matchCenter_colum1_row">
            <span class="delegationLogo" :class="item.awayLogo ? 'isLogo' : ''">
              <img v-if="item.awayLogo" :src="item.awayLogo" />
            </span>
            <span
              class="delegationName"
              v-text="_valPerFormatHandler(item.awayName)"
            ></span>
          </span>
        </span>
        <span class="matchCenter_colum2">
          <span class="matchCenter_colum2_row" v-text="item.homeScore"></span>
          <span class="matchCenter_colum2_row" v-text="item.awayScore"></span>
        </span>
      </template>
      <template
        v-else-if="
          item.type === sportsTypeArr[0] &&
          ['tennis'].includes(matchModeObj.mode)
        "
      >
        <!-- 中网双打运动员不同国籍 -->
        <span class="matchCenter_colum1">
          <span
            class="teamColum"
            :class="[
              item.competitorType === 'D' ? 'twoRow' : 'oneRow',
              item.competitorType,
            ]"
          >
            <span
              class="matchCenter_colum1_row"
              v-for="playerItem in item.competitor1Names"
              :key="playerItem.athleteCode"
            >
              <span
                class="delegationLogo"
                :class="playerItem.countryLogo ? 'isLogo' : ''"
              >
                <img
                  v-if="playerItem.countryLogo"
                  :src="playerItem.countryLogo"
                />
              </span>
              <span
                class="delegationName"
                v-text="_valPerFormatHandler(playerItem.athleteName)"
              ></span>
            </span>
          </span>
          <span
            class="teamColum"
            :class="[
              item.competitorType === 'D' ? 'twoRow' : 'oneRow',
              item.competitorType,
            ]"
          >
            <span
              class="matchCenter_colum1_row"
              v-for="playerItem in item.competitor2Names"
              :key="playerItem.athleteCode"
            >
              <span
                class="delegationLogo"
                :class="playerItem.countryLogo ? 'isLogo' : ''"
              >
                <img
                  v-if="playerItem.countryLogo"
                  :src="playerItem.countryLogo"
                />
              </span>
              <span
                class="delegationName"
                v-text="_valPerFormatHandler(playerItem.athleteName)"
              ></span>
            </span>
          </span>
        </span>
        <span class="matchCenter_colum2">
          <span class="matchCenter_colum2_row" v-text="item.homeScore"></span>
          <span class="matchCenter_colum2_row" v-text="item.awayScore"></span>
        </span>
      </template>
      <template v-else>
        <span
          class="matchCenter_colum1"
          v-if="item.medalist && item.medalist.length > 0"
        >
          <span
            class="matchCenter_colum1_row"
            v-for="ceil in item.medalist"
            :key="ceil.playerId"
          >
            <span
              class="delegationLogo"
              :class="ceil.delegationLogo ? 'isLogo' : ''"
            >
              <img v-if="ceil.delegationLogo" :src="ceil.delegationLogo" />
            </span>
            <span
              v-if="ceil.mcompetitorType === 'A'"
              class="delegationName"
              v-text="_valPerFormatHandler(ceil.playerName)"
            ></span>
            <span
              v-if="ceil.mcompetitorType === 'T'"
              class="delegationName"
              v-text="_valPerFormatHandler(ceil.delegationName)"
            ></span>
          </span>
        </span>
        <span class="matchCenter_colum2">
          <span
            v-for="ceil in item.medalist"
            :key="ceil.playerId"
            class="matchCenter_colum2_row"
          >
            <span class="medalIcon" :class="ceil.medalType"></span>
          </span>
        </span>
      </template>
    </span>
    <!-- 对于比赛预告，比赛状态无所谓，因为肯定是未开始的比赛才会被选中，宽度不够所以隐藏比赛状态 -->
    <span
      class="item_matchRight"
      v-show="viewMode.indexOf('scheduleNotice') === -1"
    >
      <span
        class="matchRight_status"
        :class="matchStatusClassName(item)"
        v-text="
          item.scheduleStatusName || matchStatusToMatchCN(item.matchStatus)
        "
      ></span>
    </span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'CSMeet_matchItem',
  mixins: [cup_base_data_mixin],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    detailPathName: {
      type: [String, Array],
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      type: String,
      default: '',
    },
    themeClass: {
      // 不同页面视图的展示
      type: String,
      default: '',
    },
    viewMode: {
      // 相同页面，控制不同视图的展示;这个就是matchListViewMode中的元素
      type: String,
      default: '',
    },
    channelType: {
      type: String,
      default: 'radio', //频道选择的模式，radio:单选；checkbox:多选
    },
    matchStatusOpts: {
      type: [Object, null],
      default: null,
    },
    matchModeObj: {
      // 各个赛事都有赛程，但是也有互相复用的，因此抽离一个共用的赛程视图
      type: [Object, null],
      default: () => ({
        mode: '', //['compreSportsMeet', 'FIFAWorldCup']=['综合性赛事', '足球世界杯'|'世界杯亚洲预选赛', ]
        type: '',
        filterCondition: '',
        // any: xxx, 根据不同情况添加不同字段
      }),
    },
    sportsTypeArr: {
      type: [Array, null],
      default: null,
    },
  },
  data() {
    return {
      // apiVal2WebValMap: {
      //   1: 0,
      //   2: 1,
      //   3: 3,
      //   4: 2,
      //   5: 0,
      //   6: 3,
      // },
      // webValStyleArr: [
      //   {
      //     colorClass: 'unstart',
      //     key: [1, 5], //['未开始', '延期']
      //     name: ['赛前分析', '赛前分析'],
      //   },
      //   {
      //     colorClass: 'playing',
      //     key: [2], // 进行中
      //     name: ['节次+时间'],
      //   },
      //   {
      //     colorClass: 'finished',
      //     key: [4], // 已完赛
      //     name: ['数据统计'],
      //   },
      //   {
      //     colorClass: 'other', // 置灰，不可点
      //     key: [3, 6],
      //     name: ['已取消', '待定'],
      //   },
      // ],
      // apiVal2WebValMap: {
      //   'Pre-Game': 0,
      //   'in-Progress': 1,
      //   Final: 2,
      //   Cancelled: 3,
      //   Postponed: 0,
      //   TBD: 3,
      // },
      // webValStyleArr: [
      //   {
      //     colorClass: 'unstart',
      //     key: ['Pre-Game', 'Postponed'], //['未开始', '延期']
      //     name: ['赛前分析', '赛前分析'],
      //   },
      //   {
      //     colorClass: 'playing',
      //     key: ['in-Progress'], // 进行中
      //     name: ['节次+时间'],
      //   },
      //   {
      //     colorClass: 'finished',
      //     key: ['Final'], // 已完赛
      //     name: ['数据统计'],
      //   },
      //   {
      //     colorClass: 'other', // 置灰，不可点
      //     key: ['Cancelled', 'TBD'],
      //     name: ['已取消', '待定'],
      //   },
      // ],
    }
  },
  methods: {
    matchStatusToMatchCN(matchStatus, dataItem) {
      if (!this.matchStatusOpts) return
      const { apiVal2WebValMap, webValStyleArr } = this.matchStatusOpts
      let index = apiVal2WebValMap[matchStatus]
      let item = webValStyleArr[index] || {}
      let matchCN = item.name?.[item.key?.indexOf(matchStatus)] || ''
      console.debug(
        'matchStatusToMatchCN:',
        this.item,
        this.matchModeObj,
        dataItem,
        matchStatus,
        index,
        item,
        matchCN
      )
      // if (item.colorClass === 'playing') {
      //   matchCN = `${this._valPerFormatHandler(
      //     dataItem.currentPeriodName
      //   )} ${this._valTimeFormatHandler(
      //     dataItem.timeMinutes
      //   )}:${this._valTimeFormatHandler(dataItem.timeSeconds)}`
      // }
      return this._valPerFormatHandler(matchCN)
    },
    matchStatusClassName(item) {
      console.log('matchStatusClassName111:', item)
      if (this.matchStatusOpts) {
        return ''
      } else {
        return this.matchStatusOpts.webValStyleArr[
          this.matchStatusOpts.apiVal2WebValMap[item.matchStatus]
        ].colorClass
      }
    },
    matchItem_checkbox(matchItem, actItem) {
      this.$emit('clickMatchItemCheckboxItemEvent', {
        matchItem,
        actItem,
        type: this.channelType ? this.channelType : '',
      })
      console.debug('matchItem_checkbox')
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    _valTimeFormatHandler(val) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '00'
      } else {
        if (val - 0 <= 9) {
          data = `0${val}`
        }
        data = val
      }
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .matchItemRow {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: auto;
    width: 100%;
    padding: 0.694vw 1.388vw;
    color: var(--mixtmt_greyColor3);
    /* border-bottom: 1px solid var(--mixtmt_greyColor5); */
    transition: padding 0.3s linear;
    &.onlyDisplay {
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 42.53vw;
        &.isShowChannelTvList {
          width: 50vw;
        }
        .matchLeft_colum1 {
          width: calc(100% - 30.3vw);
        }
        .matchLeft_colum2 {
          width: 30.3vw;
        }
      }
      .item_matchCenter {
        width: 19.75vw;
      }
    }
    .matchLeft_colum1,
    .matchLeft_colum2,
    .matchCenter_colum1,
    .matchCenter_colum2 {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      height: auto;
    }
    .matchLeft_colum1_row1,
    .matchLeft_colum2_row1,
    .matchCenter_colum1_row,
    .matchCenter_colum2_row {
      margin-bottom: 0.347vw;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .item_matchLeft {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 41.53vw;
      transition: width 0.3s linear;
      &.doubleNationalityOfTeam {
        /* 中网双打因为一只球队有俩个国家，整体变高 */
        .matchLeft_colum1 {
          .matchLeft_colum1_row1,
          .matchLeft_colum1_row2 {
            line-height: 3.2vw;
            height: 3.2vw;
          }
        }
        .matchLeft_colum2 {
          .matchLeft_colum2_row1,
          .matchLeft_colum2_row2 {
            line-height: 3.2vw;
            height: 3.2vw;
          }
        }
      }
      &.isShowChannelTvList {
        width: 60vw;
        .matchLeft_colum1_row1,
        .matchLeft_colum1_row1_colum2 {
          width: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
        }
        .matchLeft_colum1_row1_colum2 {
          margin-left: 1.11vw;
        }
      }
      .matchLeft_colum1 {
        width: calc(100% - 30vw);
        .matchLeft_colum1_row1 {
          width: 100%;
          font-size: 1.388vw;
          line-height: 2.083vw;
          height: 2.083vw;
          font-weight: bold;
          position: relative;
        }
        .matchLeft_colum1_row2 {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 2.083vw;
        }
        .matchLeft_colum2_rowComment {
          position: absolute;
          top: 3.5vw;
          line-height: 1;
        }
        .national_icon {
          padding-right: 0.694vw;
          width: 2.083vw;
          height: 0.903vw;
          overflow: hidden;
          background-image: var(--mixtmt_china_square_icon);
          background-size: auto 100%;
          background-repeat: no-repeat;
          background-position: left center;
        }
        .medal_icon {
          padding-right: 0.694vw;
          width: 1.805vw;
          height: 1.11vw;
          overflow: hidden;
          background-image: var(--mixtmt_medal_gold_icon);
          background-size: auto 100%;
          background-repeat: no-repeat;
          background-position: left center;
        }
      }
      .matchLeft_colum2 {
        width: 30vw;
        .matchLeft_colum2_row1 {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 1.38vw;
          line-height: 2.083vw;
          height: 2.083vw;
          font-weight: bold;
        }
        .matchLeft_colum2_row2 {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 2.083vw;
          .sportHall_icon {
            width: 1.11vw;
            height: 1.11vw;
            background-image: var(--mixtmt_scheduleMatchList_sportHall_icon);
            background-size: 100% auto;
            background-position: 0 0;
            background-repeat: no-repeat;
          }
          .sportHall_name {
            width: calc(100% - 1.11vw);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 1.11vw;
            line-height: 2.083vw;
            padding: 0 0.486vw;
            color: var(--mixtmt_greyColor2);
          }
        }
      }
    }
    .item_matchCenter {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      width: 20.75vw;
      &.doubleNationalityOfTeam {
        .teamColum {
          width: 100%;
          height: 3.2vw;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          flex-direction: column;
          margin-bottom: 0.347vw;
          height: 3.2vw;
          justify-content: center;
          &.oneRow {
            .delegationLogo {
              width: 1.68vw;
              height: 1.44vw;
            }
            .delegationName {
              font-size: 1.11vw;
            }
          }
          &.twoRow {
            .matchCenter_colum1_row {
              height: 1.4vw;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
        .matchCenter_colum1 {
          .matchCenter_colum1_row {
            margin-bottom: 0;
          }
        }
        .matchCenter_colum2 {
          .matchCenter_colum2_row {
            height: 3.2vw;
            line-height: 3.2vw;
          }
        }
      }
      .matchCenter_colum1 {
        width: 15.98vw;
        .matchCenter_colum1_row {
          width: 100%;
          height: 2.083vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .delegationLogo {
            width: 1.38vw;
            height: 1.18vw;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
          .delegationName {
            width: calc(100% - 1.38vw);
            padding-left: 0.972vw;
            font-size: 0.972vw;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .matchCenter_colum2 {
        width: calc(100% - 15.98vw);
        padding-left: 0.694vw;
        .matchCenter_colum2_row {
          width: 100%;
          height: 2.083vw;
          font-size: 0.972vw;
          line-height: 2.083vw;
          font-weight: bold;
          text-align: left;
          padding-right: 0.347vw;
        }
      }
      &.uncombat {
        .matchCenter_colum2_row {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          padding-right: 0;
          .medalIcon {
            width: 1.11vw;
            height: 1.11vw;
            overflow: hidden;
            background-size: auto 100%;
            background-repeat: no-repeat;
            background-position: left center;
            &.ME_GOLD {
              background-image: var(--mixtmt_medal_gold_icon);
            }
            &.ME_SILVER {
              background-image: var(--mixtmt_medal_silver_icon);
            }
            &.ME_BRONZE {
              background-image: var(--mixtmt_medal_bronze_icon);
            }
          }
        }
      }
    }
    .item_matchRight {
      position: absolute;
      right: 1.388vw;
      top: 50%;
      z-index: 10;
      transform: translateY(-50%);
      width: 6.94vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      .matchRight_status {
        width: 6.94vw;
        height: 2.083vw;
        line-height: 2.083vw;
        font-size: 0.972vw;
        text-align: center;
        border-radius: 0.278vw;
        &.unstart {
          color: var(--mixtmt_subColor3_1);
          border: 1px solid var(--mixtmt_subColor3_1);
        }
        &.playing {
          color: var(--mixtmt_subColor5_1);
          border: 1px solid var(--mixtmt_subColor5_1);
        }
        &.finished {
          color: var(--mixtmt_greyColor2);
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.other {
          color: var(--mixtmt_subColor1_1);
          border: 1px solid var(--mixtmt_subColor1_1);
        }
      }
    }
    .item_matchRight {
      position: absolute;
      right: 1.388vw;
      top: 50%;
      z-index: 10;
      transform: translateY(-50%);
      width: 6.94vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      .matchRight_status {
        width: 6.94vw;
        height: 2.083vw;
        line-height: 2.083vw;
        font-size: 0.972vw;
        text-align: center;
        border-radius: 0.278vw;
        &.unstart {
          color: var(--mixtmt_greyColor2);
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.playing {
          color: var(--mixtmt_subColor3_1);
          border: 1px solid var(--mixtmt_subColor3_1);
        }
        &.finished {
          color: var(--mixtmt_greyColor2);
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.other {
          background-color: var(--mixtmt_greyColor0);
          color: var(--mixtmt_greyColor2);
          border: 1px solid var(--mixtmt_greyColor0);
        }
      }
    }
    .matchItem_checkbox {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: auto;
      margin-right: 0.974vw;
      .matchItem_channelItem {
        width: 1.11vw;
        height: 1.11vw;
        border-radius: 0.208vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mixtmt_whiteColor);
        &.radio {
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.checkbox {
          border: 1px solid var(--mixtmt_greyColor2);
        }
        svg {
          opacity: 0;
          fill: var(--mixtmt_whiteColor);
          transition: all 0.3s linear;
        }
      }
      .matchItem_channelItem_text {
        padding: 0 0.374vw;
        font-size: 0.974vw;
        color: var(--mixtmt_greyColor2);
        &.channelName {
          padding: 0 0.374vw 0 0;
        }
      }
      &.act {
        .matchItem_channelItem {
          background-color: var(--mixtmt_mainColor6);
          border: 1px solid var(--mixtmt_mainColor6);
          svg {
            opacity: 1;
          }
        }
        .matchItem_channelItem_text {
          color: var(--mixtmt_mainColor6);
          font-weight: bold;
        }
      }
    }

    &.itemGreyColor {
      /* 赛程文字置灰，不可点击进入赛果 */
      /* color: var(--mixtmt_greyColor4); */
      opacity: 0.5;
    }
  }
}

.mixtmt_pc {
  .match_list_item:not(.none) {
    &:hover,
    &.choose.chooseAct {
      .matchItemRow {
        background-color: var(--mixtmt_scheduleItem_actBgColor);
        color: var(--mixtmt_whiteColor);
        .item_matchLeft {
          .matchLeft_colum1 {
            .matchLeft_colum1_row2 {
              color: var(--mixtmt_whiteColor);
            }
          }
          .matchLeft_colum2 {
            .matchLeft_colum2_row2 {
              .sportHall_name {
                color: var(--mixtmt_whiteColor);
              }
            }
          }
        }
        .item_matchRight {
          .matchRight_status.unstart {
            color: var(--mixtmt_scheduleItem_actBgColor);
            background-color: var(--mixtmt_whiteColor);
            border: 1px solid var(--mixtmt_whiteColor);
          }
          .matchRight_status.playing {
            color: var(--mixtmt_whiteColor);
            background-color: var(--mixtmt_subColor3_1);
            border: 1px solid var(--mixtmt_subColor3_1);
          }
          .matchRight_status.finished {
            color: var(--mixtmt_scheduleItem_actBgColor);
            background-color: var(--mixtmt_whiteColor);
            border: 1px solid var(--mixtmt_whiteColor);
          }
          .matchRight_status.other {
            background-color: var(--mixtmt_greyColor0);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor0);
          }
        }
        .matchItem_checkbox {
          cursor: pointer;
          .matchItem_channelItem {
            border: 1px solid var(--mixtmt_mainColor6);
            background-color: var(--mixtmt_whiteColor);
            svg {
              fill: var(--mixtmt_whiteColor);
            }
          }
          .matchItem_channelItem_text {
            color: var(--mixtmt_whiteColor);
          }
          &.act {
            .matchItem_channelItem {
              background-color: var(--mixtmt_mainColor6);
              border: 1px solid var(--mixtmt_mainColor6);
              svg {
                opacity: 1;
              }
            }
            .matchItem_channelItem_text {
              color: var(--mixtmt_whiteColor);
            }
          }
        }
      }
    }
    &.choose.chooseAct,
    &.choose,
    &.default {
      cursor: pointer;
    }
  }
}
</style>
